import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import Dashboard from '../../components/admin/Dashboard';
import ConfigurationForm from '../../components/admin/ConfigurationForm';
import SubscriberTable from '../../components/admin/SubscriberTable';
import EmailComposer from '../../components/admin/EmailComposer';
import MigrationTools from '../../components/admin/MigrationTools';

const AdminDashboard: React.FC = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/config" element={
          <div className="space-y-8">
            <h2 className="text-2xl font-bold mb-6">Site Configuration</h2>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-semibold mb-4">General Settings</h3>
              <ConfigurationForm section="general" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-semibold mb-4">Header Settings</h3>
              <ConfigurationForm section="header" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-semibold mb-4">Content Settings</h3>
              <ConfigurationForm section="content" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-semibold mb-4">Footer Settings</h3>
              <ConfigurationForm section="footer" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-semibold mb-4">Vanta Birds Settings</h3>
              <ConfigurationForm section="vanta" />
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-semibold mb-4">SEO Settings</h3>
              <ConfigurationForm section="seo" />
            </div>
          </div>
        } />
        <Route path="/subscribers" element={
          <div>
            <h2 className="text-2xl font-bold mb-6">Subscriber Management</h2>
            <div className="mb-6">
              <MigrationTools />
            </div>
            <SubscriberTable />
          </div>
        } />
        <Route path="/communications" element={
          <div>
            <h2 className="text-2xl font-bold mb-6">Communication Tools</h2>
            <EmailComposer />
          </div>
        } />
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminDashboard;